import styled from "styled-components";
import { Tooltip } from "@vds/tooltips";
import { CustomisedTertiaryButton, ModalBox } from "../constants/common/StyledGlobalConstants";

// Constants to avoid string duplication
const FONT_FAMILY = "neue-haas-grotesk-text";
const PADDING_VALUES = {
  MARGIN: "0px 0px 0px 0px",
  SMALL: "7px 0px 0px 0px",
  LARGE: "20px 0px 0px 0px"
};

// Helper function to extract complex ternary operation
const getPaddingValue = (props) => {
  if (props.showMargin) return PADDING_VALUES.MARGIN;
  if (props.windowSize <= 679) return PADDING_VALUES.SMALL;
  return PADDING_VALUES.LARGE;
};

// Helper function for toggle background color
const getToggleBackgroundColor = (isYes, disabled) => {
  if (isYes) {
    return disabled ? "#d8dada !important;" : "#939393 !important;";
  }
  return "#939393 !important;";
};

// Helper function for toggle button position and color
const getToggleButtonStyles = (isYes, disabled) => {
  const top = isYes ? "-4px !important" : "-5px !important";
  const left = isYes ? "16px !important" : "-1px !important";
  
  let backgroundColor;
  let border = "";
  
  if (isYes) {
    backgroundColor = disabled ? "#9e9e9e !important;" : "#000 !important;";
  } else {
    backgroundColor = "#ffffff !important;";
    border = "border: 1px solid #dddada !important;";
  }
  
  return { top, left, backgroundColor, border };
};

export const ContactWrapper = styled.div`
  width: 100%;
`;

export const MediumTextTableHeader = styled.th`
  text-transform: uppercase;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1rem;
  font-family: ${FONT_FAMILY}, Helvetica, Ariel;
  @media (min-width: 1024px) {
    font-family: ${FONT_FAMILY};
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.25rem;
  }
`;

export const CustomTooltip = styled(Tooltip)`
  font-size: 0.75rem;
  & span {
    & span {
      word-break: break-word;
    }
  }
  @media (min-width: 1024px) {
    font-family: ${FONT_FAMILY};
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }
`;

export const CPFontStyle = {
  fontFamily: FONT_FAMILY,
  fontSize: "0.75rem",
  fontWeight: 400,
  lineHeight: "1.125rem",
  color: "black",
};
export const TextWrapper = styled.p`
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : FONT_FAMILY)};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  padding: ${(props) => (props.padding ? props.padding : "")};
  letter-spacing: 0;
`;

export const StyledModalBox = styled(ModalBox)`
  width: ${(props) => (props.width ? props.width : "608px")};
  min-width: ${(props) => (props.width ? props.width : "608px")};
  height: ${(props) => (props.height ? props.height : "243px")};
  margin: ${(props) => (props.margin ? props.margin : "0")};
  box-shadow: 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12), 0px 11px 15px -7px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 24px;
  min-height: ${(props) => (props.minHeight ? props.minHeight : "180px")};
  & div {
    min-height: 0px !important;
    padding: ${getPaddingValue};
    overflow: hidden;
    & div {
      & div {
        & footer {
          padding-top: ${(props) => (props.padding ? props.padding : "1.5rem")};
          padding-bottom: 0rem !important;
        }
      }
    }
  }
`;

export const AddContactContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.ismobile ? "column" : "row")};
  line-height: 20px;
  font-size: 14px;
  font-family: ${FONT_FAMILY};
  font-weight: 400;
  text-align: left;
  margin: ${(props) => (props.ismobile ? "24px 16px" : "32px 0 0 0")};
`;
export const AddContactText = styled.div`
  margin: 0;
`;
export const LearnSpan = styled.span`
  margin: 0 0 0 5px;
`;
export const AddContactButton = styled.div`
  margin: ${(props) => (props.ismobile ? "24px 0 0 0 " : "0 0 0 24px")};
`;

export const NotificationContainer = styled.div`
  margin: ${(props) => (props.ismobile ? "24px 0 0 0 " : "32px 0 -8px 0")};
`;

export const AddContactModalContainer = styled.div`
  font-family: ${FONT_FAMILY};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  margin: 16px 0 0 0;
`;

export const CustomCancelButton = styled(CustomisedTertiaryButton)`
  /* Removed commented out focus styles */
`;

export const SortIconStyleOneInvoice = styled.img`
  width: 0.75rem;
  position: relative;
  top: 0.15rem;
  left: 0.25rem;
  margin-bottom: 2px;
`;

export const SortIconStyleInvoice = styled.img`
  width: 0.75rem;
  position: relative;
  top: 0.15rem;
  left: 0.25rem;
`;

export const CustomToggleWrapper = styled.div`
  & div {
    & label {
      height: 1.5rem !important;
      width: 3.25rem !important;
      margin-top: 4px !important;
      &:before {
        outline: none !important;
        border: none !important;
      }
      & span {
        height: 14px !important;
        border: 0px !important;
        width: 34px !important;
        top: 3px !important;
        background-color: ${(props) => getToggleBackgroundColor(props.isYes, props.disabled)};
      }
      & span::before {
        width: 20px !important;
        height: 20px !important;
        ${(props) => {
          const styles = getToggleButtonStyles(props.isYes, props.disabled);
          return `
            top: ${styles.top};
            left: ${styles.left};
            background-color: ${styles.backgroundColor};
            ${styles.border}
          `;
        }}
        box-shadow: none;
      }
    }
  }
`;
